import { useState } from 'react';
import { useTheme } from 'styled-components';
import useTestInformationDetailPageController from '../../../1_application/test/testItemDetailPageController';
import { Test, TestContext } from '../../../2_domain/test/test';
import withAsync from '../../../lib/asyncBounrdary/withAsync';
import BoxContainer, {
  OneLineBoxContainer,
} from '../../core/components/box/boxContainer';
import Column from '../../core/components/box/column';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import LXLargeButton from '../../core/components/buttons/lxLargeButton';
import LXMiddleButton from '../../core/components/buttons/lxMiddleButton';
import LXError from '../../core/error/lx_error';
import LXSpinner from '../../core/spinner/lx_spinner';
import { LXLabelInput } from '../../core/texts/lxInput';
import { LXbody, LXh2, LXh3 } from '../../core/texts/lxText';
import TestItemView from './testItemView';

interface TestCancelDialogProps {
  test: Test;
  onGoBack: () => Promise<void>;
  onCancel: (reason: string) => Promise<void>;
}

export const TestCancelDialog = (props: TestCancelDialogProps) => {
  const theme = useTheme();
  const [reason, setReason] = useState('');

  const proferFundableText = () => {
    if (props.test.testStatus.context === TestContext.READY) {
      return theme.texts.refundable;
    } else {
      return theme.texts.nonrefundable;
    }
  };

  return (
    <Column justifyContent="space-between" alignItems="center">
      <SizedBox height={30}></SizedBox>
      <LXh3>{theme.texts.cancelTest}</LXh3>
      <SizedBox height={8}></SizedBox>
      <Row>
        <LXbody color={theme.colors.caption}>{theme.texts.thisTestIs}</LXbody>
        <SizedBox width={4}></SizedBox>
        <LXbody color={theme.colors.caption}>{proferFundableText()}</LXbody>
      </Row>
      <SizedBox height={30}></SizedBox>
      <OneLineBoxContainer>
        <Row>
          <LXbody color={theme.colors.caption}>{theme.texts.testNo}</LXbody>
          <SizedBox width={4}></SizedBox>
          <LXbody>{props.test.serial}</LXbody>
        </Row>
      </OneLineBoxContainer>
      <SizedBox height={24}></SizedBox>
      <LXLabelInput
        width={420}
        label={`${theme.texts.reasonForCancellation} (${theme.texts.optional})`}
        onChange={setReason}
        isMultiline={true}
        placeholder={theme.texts.eXchangePaymentMethod}
      ></LXLabelInput>
      <SizedBox height={30}></SizedBox>
      <Row justifyContent="center">
        <LXMiddleButton onClick={props.onGoBack} kind={'secondary'}>
          {theme.texts.goBack}
        </LXMiddleButton>
        <SizedBox width={8}></SizedBox>
        <LXMiddleButton onClick={async () => props.onCancel(reason)}>
          {theme.texts.cancelTest}
        </LXMiddleButton>
      </Row>
    </Column>
  );
};

interface TestItemDetailDialogProps {
  itemCode: Serial;
  onConfirm: () => void;
}

const TestItemDetail = (props: TestItemDetailDialogProps) => {
  const { testItem } = useTestInformationDetailPageController(props.itemCode);
  const theme = useTheme();

  if (!testItem) return <LXSpinner></LXSpinner>;
  return (
    <BoxContainer padding="0">
      <Column alignItems="center">
        <LXh2 alignSelf="flex-start">{testItem.name}</LXh2>
        <SizedBox height={40} />
        <TestItemView testItem={testItem} propWidth={'140px'}></TestItemView>
        <SizedBox height={24} />
        <LXLargeButton onClick={props.onConfirm}>
          {theme.texts.confirm}
        </LXLargeButton>
      </Column>
    </BoxContainer>
  );
};

export const TestItemDetailDialog = withAsync({
  child: TestItemDetail,
  suspenseFallback: <LXSpinner></LXSpinner>,
  errorFallback: <LXError></LXError>,
});
